import axios from 'axios'
import { history } from 'store'
import errorHandler from './errorHandler'

// for easy testing
window.axios = axios
axios.defaults.withCredentials = true

const smartDispatch = ({ dispatch }, action, data) => {
  if (!action) {
    return
  }
  if (action.call) {
    action = action(data, dispatch)
  }
  if (Array.isArray(action)) {
    return action.map(a => smartDispatch({ dispatch }, a, data))
  }
  if (action?.type) {
    return dispatch(action)
  }
}

const print = (data = null) =>
  JSON.stringify(data)
    .replace(/"(\w+)":/g, (m, g1) => `${g1}:`)
    .replace(/\'/g, '\\\'')
    .replace(/"/g, '\'')

const apiService = store => next => action => {
  const result = next(action)

  if (!action.meta?.url) return result

  const { data = null, method = 'GET', url, params, onSuccess, onError } = action.meta

  return axios(url, { method, data, params }).then(
    res => {
      smartDispatch(store, onSuccess, res.data)
      const type = `${action.type}_SUCCESS`

      window.lastAction = { type, data: res.data } // saved in case of rollbar error

      return next({ ...action, type, payload: res.data })
    },
    error => {
      const { status, data } = error.response || {}
      if (status == 500) return history.push('/error')

      smartDispatch(store, onError, data)
      next({ ...action, type: `${action.type}_ERROR`, error: data })

      error.message = `${action.type}_ERROR - ${status || error.message}`
      console.warn(`${error.message} REQUEST: ${print(action.meta.data)}`)
      console.warn(`${error.message} RESPONSE: ${print(data)}`)
      errorHandler({ url, status, data }, error)
    }
  )
}

export default apiService
